(() => {
  'use strict';

  const selector = 'a[href="#zv-advies-popup"], [data-zv-advice-popup], a[href*="/pages/adviesgesprek"]';
  const cssUrl = window.ZinVoltPerformance?.adviceCss;
  const scriptUrl = window.ZinVoltPerformance?.adviceJs;
  const routesRoot = window.Shopify?.routes?.root || '/';
  const fallbackUrl = `${routesRoot.replace(/\/?$/, '/')}pages/adviesgesprek`;
  const assetTimeout = 10000;
  let loadPromise = null;

  function loadAsset(type, url) {
    return new Promise((resolve, reject) => {
      if (!url) {
        reject(new Error(`Advice ${type} URL missing`));
        return;
      }

      const isCss = type === 'css';
      const selector = isCss ? 'link[data-zv-advice-css]' : 'script[data-zv-advice-script]';
      const existing = document.querySelector(selector);
      if (existing && (existing.dataset.loaded === 'true' || (isCss && existing.sheet))) {
        resolve();
        return;
      }

      const asset = existing || document.createElement(isCss ? 'link' : 'script');
      if (!existing) {
        if (isCss) {
          asset.rel = 'stylesheet';
          asset.href = url;
          asset.dataset.zvAdviceCss = 'true';
        } else {
          asset.src = url;
          asset.defer = true;
          asset.dataset.zvAdviceScript = 'true';
        }
      }

      let timer;
      const cleanup = () => {
        window.clearTimeout(timer);
        asset.removeEventListener('load', onLoad);
        asset.removeEventListener('error', onError);
      };
      const onLoad = () => {
        cleanup();
        asset.dataset.loaded = 'true';
        resolve();
      };
      const onError = () => {
        cleanup();
        asset.remove();
        reject(new Error(`Advice ${type} could not be loaded`));
      };
      asset.addEventListener('load', onLoad, { once: true });
      asset.addEventListener('error', onError, { once: true });
      timer = window.setTimeout(onError, assetTimeout);
      if (!existing) document.head.appendChild(asset);
    });
  }

  function loadAdvice() {
    if (loadPromise) return loadPromise;

    loadPromise = Promise.all([loadAsset('css', cssUrl), loadAsset('script', scriptUrl)]).catch((error) => {
      // A failed prefetch must not prevent a later deliberate click from retrying.
      loadPromise = null;
      throw error;
    });
    return loadPromise;
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(selector);
    if (!trigger || trigger.dataset.zvAdviceReplay === 'true') return;
    const adviceCss = document.querySelector('link[data-zv-advice-css]');
    if (document.querySelector('[data-zv-advies-modal]')?.dataset.zvAdviceReady === 'true'
      && (adviceCss?.dataset.loaded === 'true' || adviceCss?.sheet)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    loadAdvice().then(() => {
      if (document.querySelector('[data-zv-advies-modal]')?.dataset.zvAdviceReady !== 'true') {
        window.location.href = fallbackUrl;
        return;
      }
      trigger.dataset.zvAdviceReplay = 'true';
      trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      trigger.removeAttribute('data-zv-advice-replay');
    }).catch(() => {
      window.location.href = fallbackUrl;
    });
  }, true);

  ['pointerover', 'focusin', 'touchstart'].forEach((type) => {
    document.addEventListener(type, (event) => {
      if (event.target.closest(selector)) loadAdvice().catch(() => {});
    }, { passive: type === 'touchstart', capture: true });
  });

  const isSalderingscheckPage = Boolean(document.querySelector('[data-zv-salderingscheck]'));
  const returnedFromQuickForm = new URLSearchParams(window.location.search).get('zv_advice_submitted') === '1';
  let hasPendingQuickForm = false;

  try {
    const submittedAt = Number(window.sessionStorage.getItem('zvAdviceQuickFormSubmittedAt') || 0);
    hasPendingQuickForm = submittedAt > 0 && Date.now() - submittedAt < 15 * 60 * 1000;
  } catch (error) {
    hasPendingQuickForm = false;
  }

  const hasQuickFormError = Boolean(document.querySelector('[data-zv-advice-contact-feedback="error"]'));
  if (!isSalderingscheckPage && (returnedFromQuickForm || (hasPendingQuickForm && hasQuickFormError))) {
    loadAdvice().catch(() => {});
  }
})();
